import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { CountryContext } from "../../context/country.context";
import CountryData from "../country-data/country-data.component";

const CountryPage = () => {
  const { name } = useParams();
  const { countryMap } = useContext(CountryContext);
  const [country, setCountry] = useState(countryMap[name]);

  useEffect(() => {
    setCountry(countryMap[name]);
  }, [name, countryMap]);

  return <CountryData key={country.name} country={country} />;
};

export default CountryPage;
